<style lang="stylus">
.banner
  width 100%
  text-align center
  position relative
  margin-bottom mobile(20px)
  +RWD-above($tablet)
    margin-bottom 20px

  img
    width mobile(768) // 客戶要求圖片滿版，原應設為500
    max-width 500px // 目前後台開放上傳尺寸為500px

  .banner__rectangle-0
    width mobile(210)
    position absolute
    top 0
    left 0
    +RWD-above($tablet)
      width 210px
  .banner__rectangle-1
    width mobile(195)
    position absolute
    top 48%
    right 0
    +RWD-above($tablet)
      width 195px
</style>
<template lang="pug">
.global-wrapper.banner-wrapper
  .global-container.banner-container
    .banner
      img(:src="imgUrl")
      template(v-if="haveCube")
        img.banner__rectangle-0(src="@/assets/images/static/BannerRectangle0.png")
        img.banner__rectangle-1(src="@/assets/images/static/BannerRectangle1.png")
</template>
<script>
import { defineComponent } from 'vue'
import KVPNG from '@/assets/images/TEMP/KV.png'
export default defineComponent({
  props: {
    imgUrl: {
      type: String,
      default: () => {
        return KVPNG
      }
    },
    haveCube: {
      type: Boolean,
      default: true
    }
  }
})
</script>
